// @flow
import React from "react";

import { Validation } from "../../model/validation";

import { Button } from "../button";

import { FormInput } from "../form-input";
import { LoginLink } from "../login-link/index";

type Props = {
    password1: string,
    password1Validation: Validation,
    password2: string,
    password2Validation: Validation,
    serverValidateFail: boolean,
    serverValidateMsg: ?string,
    resetted: boolean,
    status: "" | "loading",
    disabledSubmit: boolean,
    submitButtonText: string,
    onPassword1Changed: (e: Event, value: string) => any,
    onPassword2Changed: (e: Event, value: string) => any,
    onSubmit: (e: Event) => any
};

export function ResetPassword(props: Props) {
    return props.resetted ? getSuccess() : getForm(props);
}

function getSuccess() {
    return (
        <form name="resetPasswordForm" id="resetPasswordForm">
            <div className="form-row">
                Your password has been successfully updated.
                <br />
                <br />
                You can now login using your new password.
                <br />
                <br />
                <LoginLink>Login to maX</LoginLink>
            </div>
        </form>
    );
}

function getForm(props: Props) {
    return (
        <form
            name="resetPasswordForm"
            id="resetPasswordForm"
            onSubmit={props.onSubmit}
        >
            <FormInput
                inputId="password1"
                type="password"
                value={props.password1}
                valid={props.password1Validation}
                placeholder={"Password"}
                onChange={props.onPassword1Changed}
            />
            <FormInput
                inputId="password2"
                type="password"
                value={props.password2}
                valid={props.password2Validation}
                placeholder={"Re-enter Password"}
                onChange={props.onPassword2Changed}
            />
            {props.serverValidateFail && (
                <div className="form-row">
                    <div
                        className="form-error-msg form-error-msg--server"
                        dangerouslySetInnerHTML={{
                            __html: props.serverValidateMsg
                        }}
                    />
                </div>
            )}
            <div className="form-row form-row-cta">
                <Button
                    id="resetPassword"
                    type="submit"
                    disabled={props.disabledSubmit}
                    status={props.status}
                >
                    {props.submitButtonText}
                </Button>
            </div>
        </form>
    );
}
